var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0875 32.3998H11.5C11.2348 32.3998 10.9804 32.2944 10.7929 32.1069C10.6054 31.9194 10.5 31.665 10.5 31.3998V25.8123C10.4996 25.6824 10.5247 25.5538 10.574 25.4337C10.6234 25.3135 10.6959 25.2043 10.7875 25.1123L25.7875 10.1123C25.8806 10.0178 25.9915 9.94277 26.1138 9.89156C26.2361 9.84034 26.3674 9.81396 26.5 9.81396C26.6326 9.81396 26.7639 9.84034 26.8862 9.89156C27.0085 9.94277 27.1195 10.0178 27.2125 10.1123L32.7875 15.6873C32.882 15.7803 32.957 15.8913 33.0082 16.0136C33.0595 16.1359 33.0858 16.2672 33.0858 16.3998C33.0858 16.5324 33.0595 16.6637 33.0082 16.786C32.957 16.9083 32.882 17.0192 32.7875 17.1123L17.7875 32.1123C17.6955 32.2039 17.5863 32.2764 17.4661 32.3258C17.346 32.3751 17.2174 32.4002 17.0875 32.3998V32.3998Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 13.3999L29.5 20.3999",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditar);
export default __webpack_public_path__ + "static/media/editar.d017d4612072548bbb99ee0278f773c7.svg";
export { ForwardRef as ReactComponent };